import React from "react";

const Intro: React.FC = () => {

  const membership_form = (window as any).KEW.collections.membership_form[0]

  return (
    <>
      <div className="row intro">
        <div className="large-12 columns box">
          <div className="intro-copy">
            <h1>{membership_form.landing_page_title}</h1>
            <div className="mobile-image show-for-small-only">
              <img src={membership_form.landing_page_mobile_image} alt={membership_form.landing_page_image_alt} />
            </div>
            <div dangerouslySetInnerHTML={{ __html: membership_form.single_intro_text}}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Intro;